<div class="drag-drop-container" cdkDropListGroup>
  <div
    cdkDropList
    (cdkDropListEntered)="onDropListEntered($event)"
    (cdkDropListDropped)="onDropListDropped()"
  ></div>
  <div
    class="mt-3"
    cdkDropList
    [ngStyle]="{
      maxWidth: boxWidth + 'px',
      minWidth: boxWidth + 'px',
      maxHeight: boxHeight + 'px',
      minHeight: boxHeight + 'px'
    }"
    (cdkDropListEntered)="onDropListEntered($event)"
    (cdkDropListDropped)="onDropListDropped()"
    *ngFor="let item of items"
  >
    <div cdkDrag>
      <ng-container
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{ $implicit: item }"
      ></ng-container>
    </div>
  </div>
</div>
